import PageSimple from '@/components/PageSimple/PageSimple';

const TermsPage = () => (
  <PageSimple title="Terms &amp; Conditions" path="/terms" />
);

export default TermsPage;
